import { cn } from 'support/helpers/cn/cn';

export const NestedLevelAddon = ({ level, className }: { level: number; className?: string }) => {
  return (
    <div className={cn('flex gap-4 self-stretch', className)}>
      {new Array(level - 1).fill(0).map((_, i) => {
        return <NestedLevelIcon key={i} />;
      })}
    </div>
  );
};

const NestedLevelIcon = () => {
  return <div className="w-px bg-gray-300" />;
};
